'use client';

import clsx from 'clsx';
import {
  visibleStyles,
  dropdownStyles,
  dropdownContainer,
  dropdownPlacementStyles,
  dropdownAlignmentStyles,
} from './dropdown.css';
import { Box } from '../box/box';

import { ReactNode } from 'react';
import { useDismissible } from '@instamenu/react-hooks';

export const Dropdown = ({
  visible,
  children,
  placement = 'below',
  align = 'right',
}: {
  visible: boolean;
  children: ReactNode;
  placement?: keyof typeof dropdownPlacementStyles;
  align?: keyof typeof dropdownAlignmentStyles;
}) => {
  const isVisible = visible ? visibleStyles.VisibleTrue : visibleStyles.visibleFalse;

  return (
    <Box
      className={clsx(
        dropdownStyles,
        dropdownPlacementStyles[placement],
        dropdownAlignmentStyles[align],
        isVisible,
      )}
    >
      {children}
    </Box>
  );
};

export const DropdownContainer = ({
  children,
  onDismiss,
}: {
  children: ReactNode;
  onDismiss?: () => void;
}) => {
  const { ref } = useDismissible<HTMLDivElement>(() => {
    onDismiss?.();
  });
  return (
    <Box className={dropdownContainer} ref={ref}>
      {children}
    </Box>
  );
};
